export const ENDPOINTS = {
  AUTH: {
    LOGIN: "api/v1/admin/login",
    LOGOUT: "api/v1/admin/logout",
  },
  USERS: {
    LISTING: "/api/v1/admin/user-lists",
    CREATE_USER: "/api/v1/admin/create-user",
    USER_DETAIL: "/api/v1/admin/user-details",
    UPDATE_USER: "/api/v1/admin/update-user",
    GET_USER_VEHICLE: "/api/v1/shinology/car/get-user-vehicle",
    ADDRESS_LIST: "/api/v1/shinology/address/list",
  },
  UTILITY: {
    CARS_TYPE_LISTING: "/api/v1/shinology/car/carType",
    ADD_CAR_TYPE: "/api/v1/shinology/car/carType",
    SOFA_TYPE_LISTING: "/api/v1/shinology/sofa/get-sofa-type",
    TANK_TYPE_LISTING: "/api/v1/shinology/tank/get-tank-type",
    CARPET_TYPE_LISTING: "/api/v1/shinology/carpet/get-carpet-type",
    DISCOUNTS: "/api/v1/wheelandclean/discount",
    CURRENT_DISCOUNT: "/api/v1/wheelandclean/currentDiscount",
    SERVICE_CATEGORIES_LISTING: "/api/v1/shinology/services/service-categories",
  },
  SERVICE: {
    TYPE_LISTING: "/api/v1/shinology/services/service-types",
    SERVICE_LISTING: "/api/v1/shinology/services/service-price",
    CREATE: "/api/v1/shinology/services/create-services",
    DETAIL: "/api/v1/shinology/services/service-detail",
    UPDATE: "/api/v1/shinology/services/update-services",
    VEHICLE_SERVICE_LIST: "/api/v1/shinology/car/service-list",
  },
  SERVICE_PRICING: {
    SERVICE_PRICE: "api/v1/wheelandclean/getprice",
    SERVICE_PRICING_LISTING: "/api/v1/shinology/services/service-price",
    SERVICE_PRICING_BY_CAR_TYPE: "/api/v1/shinology/car/get-user-vehicle",
    UPDATE_SERVICE_PRICING: "/api/v1/shinology/services/update-services-price",
  },
  COMMON: {
    FILE_UPLOAD_REQUEST: "api/v1/shinology/fileUpload",
    GENERATE_UPLOAD_URL: "api/v1/shinology/s3/presigned-url",
    GENERATE_READ_SIGNED_URL: "api/v1/shinology/s3/read/signed-url",
    GET_MEDIA_URL: "api/v1/shinology/get-media-url",
    DELETE_FILE: "api/v1/shinology/s3/delete-file",
  },
  ORDER_MANAGEMENT: {
    ALL_ORDERS: "api/v1/admin/order/list",
    CREATE_ORDER: "/api/v1/admin/order/create",
    ORDER_DETAILS: "/api/v1/admin/order/detail",
    UPDATE_ORDER_DETAILS: "/api/v1/admin/order/edit",
  },
  COMPANIES: {
    COMPANIESLIST: "api/v1/shinology/brands/vehicleBrands",
    UPDATE_COMPANY: "/api/v1/shinology/brands/update-vehicle-brand",
    DELETE_COMPANY: "api/v1/wheelandclean/deletecarcompany",
    ADD_NEW_COMPANY: "api/v1/shinology/brands/vehicleBrands",
  },
  VEHICLE: {
    VEHICLE_LIST: "/api/v1/shinology/vehicle/get-vehicle",
    UPDATE_VEHICLE: "/api/v1/shinology/vehicle/update-vehicle",
    DELETE_VEHICLE: "api/v1/wheelandclean/deletevehicle",
    ADD_NEW_VEHICLE: "/api/v1/shinology/vehicle/create-vehicle",
    ADD_VEHICLE_TO_USER: "/api/v1/shinology/car/add-user-vehicle",
    DELETE_VEHICLE_TO_USER: "/api/v1/shinology/car/delete-user-vehicle/",
  },
  TESTIMONIAL: {
    LIST: "/api/v1/shinology/testimonial/list",
    CREATE: "/api/v1/shinology/testimonial/add-testimonial",
    UPDATE: "/api/v1/shinology/testimonial/update-testimonial",
    DELETE: "/api/v1/shinology/testimonial/delete-testimonial",
  },
  COUPON: {
    LIST: "/api/v1/shinology/coupon/coupon-list",
    CREATE: "/api/v1/shinology/coupon/create-coupon",
    DETAIL: "/api/v1/shinology/coupon/detail",
    UPDATE: "/api/v1/shinology/coupon/update-coupon",
    DELETE: "/api/v1/shinology/coupon/delete-coupon",
  },
  DASHBOARD: {
    DASHBOARD_DATA: "api/v1/wheelandclean/dashboard",
    ADMIN_DASHBOARD: "api/v1/admin/dashboard",
    VENDER_STAFF_LISTING: "api/v1/wheelandclean/getvendorstaff",
  },
  FEEDBACK: {
    LIST: "api/v1/admin/feedback-list",
  },
  BUSINESS_DETAIL: {
    DETAIL: "/api/v1/shinology/business-detail",
  },
};
